const config = {
  test: {
    apiUrl: "/api",
    serverUrl: "https://localhost:44358",
    loginUrl: "https://localhost:44360/Login",
    //},
    //apiUrl: "https://localhost:5001/api",
    //serverUrl: "https://localhost:5001"
  },
  development: {
    apiUrl: "https://uat-rates.ceylonexchange.com.au/RateCal/api",
    serverUrl: "https://uat-rates.ceylonexchange.com.au/RateCal",
    loginUrl: "https://uat-rates.ceylonexchange.com.au/RateCal/Login",
  },
  production: {
    //https://bankinterface.ceylonexchange.com.au:8080/

    apiUrl: "https://rates.ceylonexchange.com.au/RateCal/api",
    serverUrl: "https://rates.ceylonexchange.com.au/RateCal",
    loginUrl: "https://rates.ceylonexchange.com.au/RateCal/Login",
  },
};

exports.get = function get(env) {
  return config[env] || config.production;
};
